<script>
  import { createEventDispatcher } from 'svelte';
  import { fade } from 'svelte/transition';

  const dispatch = createEventDispatcher();

	const handleClick = () => {
    dispatch('reset');
  };
</script>

<style>
  button {
    float: left;
    display: none;
    text-transform: uppercase;
  }
  svg {
    height: 13px;
    width: 13px;
  }

  @media (min-width: 1024px) {   
    button {
      display: inherit;
    }
  }
</style>

<button title="Reset matrix" class="button" on:click={handleClick} in:fade>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13"><defs/><path fill="currentColor" fill-rule="nonzero" d="M11.96.646a1 1 0 01.078 1.327l-.078.088-4.242 4.242 4.242 4.243a1 1 0 01-1.327 1.492l-.087-.078-4.243-4.242L2.06 11.96a1 1 0 01-1.492-1.327l.077-.087L4.89 6.303.646 2.06A1 1 0 011.973.569l.088.077L6.303 4.89 10.546.646a1 1 0 011.414 0z"/></svg>
  إلغاء الإختيار
</button>